<div class="min-h-screen w-full bg-gray-50">
	<app-toolbar></app-toolbar>
	<router-outlet></router-outlet>
</div>
